export default __webpack_public_path__ + "static/media/blog3.fb8d0037.png";